import { Directive, EventEmitter, Output } from '@angular/core';
import { RxjsComponent } from '../../utils/rxjs.component';

/**
 * Master class for components implementing a ControlValueAccessor.
 * T the type of the input
 */
@Directive()
// tslint:disable-next-line
export abstract class CustomValueAccessorComponent<T> extends RxjsComponent {
  /**
   * Event to propagate the touched state of the component
   * Must be used if multiple CustomValueAccessor are nested to propagate correctly
   * Status throughout the entire form tree
   */
  @Output()
  emitTouched = new EventEmitter();

  /* eslint-disable */
  propagateChange = (value: T) => {};
  propagateTouched = () => {};

  registerOnChange(fn: (value: T) => void): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.propagateTouched = () => {
      fn();
      this.emitTouched.emit();
    };
  }
  /* eslint-enable */
}
